import StateTransitionAction from '@/ecm/models/workflow/StateTransitionAction'
export default class ValidationItem {
    constructor (dto) {
        this.objectID = 0
        this.flowID = 0
        this.flowName = ''
        this.contentTypeID = 0
        this.contentTypeName = ''
        this.comment = ''
        this.transitionType = ''
        this.transitionID = 0
        this.actions = []
        this.requiresCertificatePassword = false;
        this.certificatePassword = "";

        if (dto) {
            this.objectID = dto.ObjectID
            this.flowID = dto.FlowID
            this.flowName = dto.FlowName
            this.contentTypeID = dto.ContentTypeID
            this.contentTypeName = dto.ContentTypeName
            this.comment = dto.Comment
            this.transitionType = dto.TransitionType
            this.transitionID = dto.TransitionID
            this.requiresCertificatePassword = dto.RequiresCertificatePassword
            this.certificatePassword = dto.CertificatePassword
            this.actions = dto.Actions.map(function (dto) { return new StateTransitionAction(dto) })
        }
    }

    toDto () {
        return {
            ObjectID: this.objectID,
            FlowID: this.flowID,
            Comment: this.comment,
            TransitionType: this.transitionType,
            Actions: this.actions.map(x => x.toDto()),
        }
    }
}
